import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import Button from './Button';
import CurrentEventsPosts from './CurrentEventsPosts';
import Section from './Section';
import Title from './Title';

type Props = {
  serviceId: ServiceId;
};

const CurrentEvents: React.FC<Props> = ({ serviceId }): JSX.Element => {
  return (
    <Section>
      <Title text="現在の状況" />
      <CurrentEventsPosts serviceId={serviceId} />
      <Button path={`/archive/trouble/${serviceId}/`} text="過去の障害情報を見る" />
    </Section>
  );
};

export default CurrentEvents;
